import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[onlyNum]',
})
export class OnlyNumberDirective {
  private _min;
  private _max;
  private _maxLength;
  @Input()
  set maxLen(max: number | string) {
    this._maxLength = +max;
  }
  @Input()
  set minNum(min: number) {
    this._min = +min;
  }
  @Input()
  set maxNum(max: number) {
    this._max = +max;
  }
  constructor(private el: ElementRef, public model: NgControl) {}
  @HostListener('input', ['$event'])
  onEvent($event) {
    let val = this.el.nativeElement.value
      .replace(/[^0-9\.]*/g, '')
      .replace('.', 'x')
      .replace(/\./g, '')
      .replace('x', '.');
    if (this._min && val < this._min) {
      val = this._min;
    }
    if (this._max && val > this._max) {
      val = this._max;
    }
    if (
      this._maxLength &&
      (val as string).replace(/\./g, '').length > this._maxLength
    ) {
      val = (val as string).substring(0, (val as string).length - 1)
    }
    this.model.control.setValue(val);
  }
}
